import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/186afb54-ad9f-4a49-8eb9-c7e4ff21130d/images/31c1db53a7d4fab67566b842a62216d8d49cd3f5071cbec7a340efacca311804.png";

const TIMELINE = [
  { year: "2003", title: "Formation Martigues", detail: "Centre de formation, premiers pas" },
  { year: "2004", title: "Olympique Lyonnais", detail: "4 saisons en centre de formation" },
  { year: "2014", title: "National 2 US Granville", detail: "US Granville — National 2" },
  { year: "2018", title: "Le Mans FC", detail: "National puis Ligue 2 (3 saisons)" },
  { year: "2021", title: "FC Martigues", detail: "National 2, National et Ligue 2" },
  { year: "2024", title: "AS Cannes", detail: "AS Cannes 2024" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left: image + label */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#CCFF00] mb-6">
              <span className="w-8 h-px bg-[#CCFF00]" /> Le Coach
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7 }}
              className="relative aspect-[4/5] overflow-hidden rounded-sm"
            >
              <img
                src={ABOUT_IMG}
                alt="Goalkeeper gloves"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-display text-3xl leading-none">JÉRÉMY AYMES</p>
                <p className="text-xs text-zinc-300 mt-1 tracking-widest uppercase">
                  Né le 12 juillet 1988 — Martigues
                </p>
              </div>
            </motion.div>
          </div>

          {/* Right: heading + bio + timeline */}
          <div className="lg:col-span-7">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]"
              data-testid="about-title"
            >
              UN PARCOURS,
              <br />
              <span className="text-[#CCFF00]">UNE PASSION,</span>
              <br />
              <span className="text-stroke">UNE MÉTHODE.</span>
            </motion.h2>

            <p className="mt-8 text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
              Plus de 15 ans en tant que gardien de but professionnel en National
              et Ligue 2. Aujourd&apos;hui, j&apos;accompagne les gardiens de tous niveaux
              avec une approche pédagogique structurée et reconnue. Du tout
              jeune passionné au gardien semi-pro, chacun mérite un suivi
              taillé pour ses ambitions.
            </p>

            {/* Timeline */}
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
              {TIMELINE.map((t, i) => (
                <motion.div
                  key={t.year}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="bg-[#050505] p-6 group hover:bg-[#0a0a0a] transition-colors"
                  data-testid={`timeline-${t.year}`}
                >
                  <p className="font-display text-3xl text-[#CCFF00] leading-none">
                    {t.year}
                  </p>
                  <p className="mt-2 font-bold text-white text-sm uppercase tracking-wider">
                    {t.title}
                  </p>
                  <p className="mt-1 text-xs text-zinc-500">{t.detail}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
